export default __webpack_public_path__ + "static/media/CliniMACS ProdigyR HSC Engineering System.eaacd6b0.pdf";